<template>
  <section class="project-tree" :class="{'project-tree_full': activeZoom}">
    <project-tree-header ></project-tree-header>
    <project-tree-field></project-tree-field>
  </section>
</template>

<script>
  import projectTreeHeader from './projectTreeHeader'
  import projectTreeField from './projectTreeField'
  import {mapState} from 'vuex'


  export default {
    name: 'projectTree',
    components: {
      projectTreeHeader,
      projectTreeField
    },
    computed: {
      ...mapState({
        activeZoom: state => state.projects.activeZoom
      })
    },
  }
</script>

<style lang="scss" scoped>
.project-tree {
  width: calc(100% - 390px);
}

  .project-tree_full {
    width: 100%;
  }
</style>
